/** Resolving the editor's stored images (blobRef → object URL) before content reaches the editor. */
import type { JSONContent } from '@tiptap/core'
import { dynamicImageMoniker } from './schema'

/**
 * Walks a ProseMirror JSON tree collecting every stored `image` node's blobRef, deduped. An image
 * bound to a field (`dyn:`) has no asset until render time, so it is not fetched.
 */
export function collectImageBlobRefs(node: JSONContent, out: Set<string>) {
  if (node.type === 'image' && typeof node.attrs?.blobRef === 'string' && node.attrs.blobRef && dynamicImageMoniker(node.attrs) === null) {
    out.add(node.attrs.blobRef as string)
  }
  for (const child of node.content ?? []) collectImageBlobRefs(child, out)
}

/** Patches every `image` node's resolvedSource/src to the resolved object URL for its blobRef. */
export function resolveImageSources(node: JSONContent, urls: Map<string, string>): JSONContent {
  if (node.type === 'image' && typeof node.attrs?.blobRef === 'string') {
    const url = urls.get(node.attrs.blobRef as string)
    if (url) return { ...node, attrs: { ...node.attrs, resolvedSource: url, src: url } }
  }
  if (node.content) return { ...node, content: node.content.map(c => resolveImageSources(c, urls)) }
  return node
}
